import React from 'react';
import Nav from '../Page Components/Nav';
import Footer from "../Page Components/Footer";
import Card from "../Co Components/SquareCards";
import Square from "../Co Components/SquareCards";
import Title from "../Co Components/Titles";
import FAQ from '../assets/Images/FAQs.png';
import Rectangle from "../Co Components/RectangleCards";
import LineButton from "../Co Components/LineButton";
import logo from "../assets/Images/whitehawk/logo only WH_black.png";
import { useEffect } from 'react';
import {Col, Row} from "react-bootstrap";

const Impact = () => {

    return (
        <>
            <div className={'d-flex flex-row flex-wrap justify-content-center mt-5'} >
               <Col xl={5} lg={5} md={5}>
                   <div className={'d-flex flex-column flex-wrap align-items-center'}>
                       <div className={'impactDiv '}>
                           <h5 style={{padding:'10px',fontWeight:'bolder',color:'black',textAlign:'center'}}>
                               Easy integration with SIEM solution and SOC team
                           </h5>
                       </div>
                       <div className={'impactDiv mt-6 mb-6'}>
                           <h5 style={{padding:'10px',fontWeight:'bolder',color:'black',textAlign:'center'}}>
                               Replace a range of manual tasks with automation
                           </h5>
                       </div>
                       <div className={'impactDiv'}>
                           <h5 style={{padding:'10px',fontWeight:'bolder',color:'black',textAlign:'center'}}>
                               See potential exposure impact in real-time
                           </h5>
                       </div>
                   </div>
               </Col>
                <Col xl={2} lg={2} md={2}>
                    <img src={logo} style={{width:'100%',height:'80%',boxShadow:'100px',marginTop:'50px'}} className={'LogoImage d-none d-lg-block'}/>
               </Col >
                <Col xl={5} lg={5} md={5}>
                    <div className={'d-flex flex-column flex-wrap align-items-center'}>
                       <div className={'impactDiv '}>
                           <h5 style={{padding:'10px',fontWeight:'bolder',color:'black',textAlign:'center'}}>
                               Assist in crises operation

                           </h5>
                       </div>
                       <div className={'impactDiv mt-6 mb-6'}>
                           <h5 style={{padding:'10px',fontWeight:'bolder',color:'black',textAlign:'center'}}>
                               Continuous threat and emerging risk management
                           </h5>
                       </div>
                       <div className={'impactDiv'}>
                           <h5 style={{padding:'10px',fontWeight:'bolder',color:'black',textAlign:'center'}}>
                               Combine talents and technology to empower
your security posture
                           </h5>
                       </div>
                   </div>
               </Col>
            </div>
        </>
    );

}

export default Impact;